import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-013270f1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "electricity-content border-b"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "me-top-lg"
}, "电力业务管理困境", -1));
const _hoisted_3 = {
  class: "advance-card me-top-lg"
};
const _hoisted_4 = {
  class: "advance-wrap"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left-wrap"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "left-card-item"
}, [/*#__PURE__*/_createElementVNode("label", {
  class: "me-sub-title"
}, "缺乏有效监管"), /*#__PURE__*/_createElementVNode("div", {
  class: "describe me-content-lt"
}, " 煤源地监管机制不健全， 质量及安全治理无法保障 ")])], -1));
const _hoisted_6 = {
  class: "right-wrap"
};
const _hoisted_7 = {
  class: "right"
};
const _hoisted_8 = {
  class: "me-sub-title"
};
const _hoisted_9 = {
  class: "describe me-content-lt"
};
const _hoisted_10 = {
  class: "sys-info bulk-wrap"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "智能调运管理系统", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info dis-space-1"
}, " 针对电厂燃料管理中存在的煤源地监管、在途风险、运输信息滞后等问题，通过智能燃料调运管理系统，结合自主研发智运盒等硬件产品，帮助电厂将燃料发、运、收全流程建立在一个平台上，建设调运计划、运输监管、厂收接卸一体化管控架构，实现燃料调运计划、矿发数据采集、运输过程监管、厂收接卸的全业务流程管理。 ", -1));
const _hoisted_13 = {
  class: "sys-imgPanel"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "电力场景业务详解图", -1));
const _hoisted_16 = [_hoisted_15];
const _hoisted_17 = {
  class: "img-box"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  class: "sys-info bulk-wrap"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "软件界面", -1));
const _hoisted_21 = {
  class: "pa-top-t"
};
const _hoisted_22 = ["src"];
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "硬件设备", -1));
const _hoisted_24 = {
  class: "list-box"
};
const _hoisted_25 = ["src"];
const _hoisted_26 = ["src"];
const _hoisted_27 = ["src"];
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "dis-space-3"
}, "核心优势", -1));
const _hoisted_29 = {
  class: "advance-card me-top"
};
const _hoisted_30 = {
  class: "left"
};
const _hoisted_31 = ["src"];
const _hoisted_32 = {
  class: "right"
};
const _hoisted_33 = {
  class: "me-content-lg"
};
const _hoisted_34 = {
  class: "me-content-lt"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["bulk-wrap electricity-plight", {
      'electricity-plight-entry': _ctx.electricityPlightState.showTime
    }]),
    id: "electricity-plight"
  }, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.powerList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "right-card-item",
      key: index,
      style: _normalizeStyle({
        background: `url(${item.img})`,
        'background-size': 'cover'
      })
    }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("label", _hoisted_8, _toDisplayString(item.title), 1), _createElementVNode("span", _hoisted_9, _toDisplayString(item.text), 1)])], 4);
  }), 128))])])])], 2)]), _createElementVNode("div", {
    class: _normalizeClass(["pa-wrap intelligence-system", {
      'intelligence-system-entry': _ctx.intelligenceSystemState.showTime
    }]),
    id: "intelligence-system"
  }, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _hoisted_12, _createElementVNode("div", _hoisted_13, [_createElementVNode("img", {
    src: _ctx.sysImg1
  }, null, 8, _hoisted_14)])])], 2), _createElementVNode("div", {
    class: _normalizeClass(["power-scene power-detailed", {
      'power-detailed-entry': _ctx.powerDetailedState.showTime
    }]),
    id: "power-detailed"
  }, _hoisted_16, 2), _createElementVNode("div", {
    class: "whirt-bg-wrap process-img",
    style: _normalizeStyle({
      padding: _ctx.boxPadding,
      height: _ctx.height
    })
  }, [_createElementVNode("div", _hoisted_17, [_createElementVNode("img", {
    src: _ctx.sysImg2
  }, null, 8, _hoisted_18)])], 4), _createElementVNode("div", {
    class: _normalizeClass(["pa-wrap software-interface", {
      'software-interface-entry': _ctx.softwareInterfaceState.showTime
    }]),
    id: "software-interface"
  }, [_createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("div", _hoisted_21, [_createElementVNode("img", {
    src: _ctx.sysImg3
  }, null, 8, _hoisted_22)])])], 2), _createElementVNode("div", {
    class: _normalizeClass(["equipment-box whirt-bg-wrap hardware-equipment", {
      'hardware-equipment-entry': _ctx.hardwareEquipmentState.showTime
    }]),
    id: "hardware-equipment"
  }, [_hoisted_23, _createElementVNode("div", _hoisted_24, [_createElementVNode("img", {
    src: _ctx.equipmentImg1,
    alt: ""
  }, null, 8, _hoisted_25), _createElementVNode("img", {
    src: _ctx.equipmentImg2,
    alt: ""
  }, null, 8, _hoisted_26), _createElementVNode("img", {
    src: _ctx.equipmentImg3,
    alt: ""
  }, null, 8, _hoisted_27)])], 2), _createElementVNode("div", {
    class: _normalizeClass(["center-content core-advantage", {
      'core-advantage-entry': _ctx.coreAdvantageState.showTime
    }]),
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    }),
    id: "core-advantage"
  }, [_hoisted_28, _createElementVNode("div", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.powerSuperList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "advance-item",
      key: index
    }, [_createElementVNode("div", _hoisted_30, [_createElementVNode("img", {
      src: item.img
    }, null, 8, _hoisted_31)]), _createElementVNode("div", _hoisted_32, [_createElementVNode("label", _hoisted_33, _toDisplayString(item.title), 1), _createElementVNode("span", _hoisted_34, _toDisplayString(item.text), 1)])]);
  }), 128))])], 6)]);
}